module.exports = __webpack_public_path__ + "static/media/8.1c966876.jpg";